import o from "./index222.js";
/* empty css         */
import t from "./index130.js";
const p = /* @__PURE__ */ t(o, [["__scopeId", "data-v-e4b61816"]]);
export {
  p as default
};
